/** Default stage_10 from themesets.js theme0 — used when API stages_data omits this stage. */
export const THEME0_STAGES_SKELETON = {
  stage_10: {
    type: "native_places",
    rules: [
      "Every teammate shares their hometown or native place.",
      "Together, identify one famous food, landmark, fun fact, and must-visit experience for each place.",
      "Build your own mini travel guide before time runs out.",
    ],
    questions: "",
    logo: "streak_8_days.png",
    title: "Around the Map We Go!",
    description:
      "Mumbai<br/>Food<br/>Vada Pav<br/>Landmark<br/>Gateway of India<br/>Fun Fact<br/>Home to India's largest film industry.<br/>Must Try<br/>Marine Drive at sunset.<br/>",
    timer: "03:00",
  },
};
